import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getBaseUrl } from "../config/apiConfig";

function ForgotPasswordForm({ onClose }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      const response = await fetch(
        `${getBaseUrl()}/api/user/forgot-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );
      if (response.ok) {
        setStatus("success");
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="bg-white/95 backdrop-blur-[20px] rounded-[2rem] p-8 sm:p-12 shadow-[0_24px_80px_rgba(0,0,0,0.2)] border border-white/30 max-w-[450px] w-full relative animate-in zoom-in duration-500">
      <button
        onClick={onClose}
        className="absolute right-6 top-6 w-10 h-10 flex items-center justify-center rounded-full bg-slate-100 text-slate-500 transition-all hover:bg-red-500 hover:text-white hover:rotate-90"
      >
        <span className="text-xl font-bold">×</span>
      </button>

      <h2 className="text-2xl font-[800] bg-gradient-to-br from-[#0f7699] to-[#4c9fb9] bg-clip-text text-transparent mb-8 text-center">
        {t("forgotPassword.title")}
      </h2>

      {status === "success" ? (
        <div className="text-center py-4">
          <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg shadow-green-500/30">
            <span className="text-white text-3xl">✓</span>
          </div>
          <p className="text-slate-600 font-medium">
            {t("forgotPassword.successMessage")}
          </p>
          <button
            onClick={onClose}
            className="mt-8 bg-slate-200 text-slate-700 font-bold px-8 py-3 rounded-xl transition-all hover:bg-slate-300"
          >
            {t("forgotPassword.close")}
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
          <div className="relative">
            <input
              type="email"
              placeholder={t("forgotPassword.emailPlaceholder")}
              className="w-full bg-slate-50 border border-slate-200 rounded-xl px-5 py-4 text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-[#0f7699] focus:border-transparent transition-all"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            disabled={status === "sending"}
            className="w-full h-14 rounded-xl text-base font-bold bg-gradient-to-br from-[#0f7699] to-[#4c9fb9] text-white shadow-[0_8px_24px_rgba(15,118,153,0.3)] transition-all duration-300 hover:from-[#0a5f7a] hover:to-[#0f7699] hover:shadow-[0_12px_32px_rgba(15,118,153,0.4)] hover:-translate-y-0.5 active:translate-y-0 disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {status === "sending" ? "..." : t("forgotPassword.submit")}
          </button>
        </form>
      )}

      {status === "error" && (
        <div className="mt-6 p-4 rounded-xl bg-red-50 border border-red-100 text-red-600 text-sm text-center font-medium animate-in fade-in slide-in-from-top-2 duration-300">
          {t("forgotPassword.errorMessage")}
        </div>
      )}
    </div>
  );
}

export default ForgotPasswordForm;
